'use client';

import { useState } from 'react';
import { SmallButton } from '../button';
import { ModalVideo } from '../video-player';
import Link from 'next/link';

interface IPlayCardProps {
  desc: string;
  type?: 'arrowRight' | 'video';
  prefix?: string;
  linkHref?: string;
}

const typeTexts = {
  arrowRight: '详情',
  video: '播放视频',
};

const VideoButton = ({
  type,
  linkUrl,
}: {
  type: 'arrowRight' | 'video';
  linkUrl: string;
}) => {
  const [visible, setVisible] = useState(false);

  const onClose = () => {
    setVisible(false);
  };
  const onShow = () => {
    setVisible(true);
  };
  return (
    <>
      <SmallButton type={type} onClick={onShow}>
        {typeTexts[type]}
      </SmallButton>
      {visible && (
        <ModalVideo url={linkUrl} visible={visible} close={onClose} />
      )}
    </>
  );
};

export const PlayCard: React.FC<IPlayCardProps> = ({
  desc,
  type = 'arrowRight',
  prefix,
  linkHref,
}) => {
  return (
    <div className="bg-bg p-[30px] rounded-lg flex flex-col h-[232px] justify-between mobile:p-5">
      <div>
        <span className="text-primary/[.6] text-sm leading-none line-clamp-1">
          {prefix}
        </span>
        <p className="text-primary text-base -leading-[1px] mt-2 line-clamp-3 font-500 break-all">
          {desc}
        </p>
      </div>
      <div className='flex'>
        {linkHref ? (
          <Link href={linkHref} target="_blank" >
            <SmallButton type={type}>{typeTexts[type]}</SmallButton>
          </Link>
        ) : (
          <SmallButton type={type}>{typeTexts[type]}</SmallButton>
        )}
      </div>
    </div>
  );
};
